'use client'

import { useEffect, useRef } from 'react'
import { clampTabTitle } from '@/lib/notebook/models/tabs-model'
import { stripHtmlToPlainText } from '@/lib/notebook/text/plain-text-value'

/**
 * Native tab rename field — stable focus (no Tiptap / ActiveEditor).
 */
export function TabRenameInput({
  value,
  maxLength,
  onCommit,
  onCancel,
  className = '',
}) {
  const inputRef = useRef(null)
  const initial = stripHtmlToPlainText(value)

  useEffect(() => {
    const el = inputRef.current
    if (!el) return
    el.focus()
    el.select()
  }, [])

  const commit = () => {
    const next = clampTabTitle(inputRef.current?.value ?? initial)
    onCommit(next || initial)
  }

  return (
    <input
      ref={inputRef}
      type="text"
      className={className}
      defaultValue={initial}
      maxLength={maxLength}
      size={Math.max(2, Math.min(initial.length || 4, 14))}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onBlur={commit}
      onKeyDown={(e) => {
        e.stopPropagation()
        if (e.key === 'Enter') {
          e.preventDefault()
          commit()
        }
        if (e.key === 'Escape') {
          e.preventDefault()
          onCancel?.()
        }
      }}
    />
  )
}
